import { useMemo } from 'react';
import { useMyCompanyUser } from '@/companies/hooks';
import { getBrowserTimezone } from '../util/timezones';

export type TimeSettings = {
    timezone: string;
    use24HourClock: boolean;
};

/**
 * Resolves the current user's time settings, falling back to the browser
 * timezone and a 12 hour clock when the company user is unavailable.
 */
export function useTimeSettings(): TimeSettings {
    const companyUser = useMyCompanyUser();

    return useMemo(
        () => ({
            timezone: companyUser?.timezone ?? getBrowserTimezone(),
            use24HourClock: companyUser?.use24HourClock ?? false
        }),
        [companyUser?.timezone, companyUser?.use24HourClock]
    );
}
